"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_app_controller_reducers_sagas_modals_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.modals-reducer");
const next_components_text_info_n_1 = __importStar(require("@gerenciatd/next.components.text-info-n"));
const utils_1 = require("../../ModalsContent/utils");
const utils_2 = require("./utils");
const Menu = (props) => {
    const { menu, addModal } = props;
    const { taggingInfo, modalProps, segment, isGestor } = props;
    if (!menu) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "Menu" }, menu.map((item) => {
        let onClick = null;
        let link = '';
        const { selected } = item;
        if (!item.link && item.action && item.action.id) {
            onClick = () => (0, utils_1.handleModal)(item.action.id, modalProps, item, addModal);
        }
        if (item && item.link) {
            ({ link } = item);
        }
        const { color, fontType } = (0, utils_2.setTextInfoAppearance)(segment, selected, isGestor);
        const linkToShow = link.indexOf('//') === -1 ? `https://www.movistar.es${link}` : link;
        if ((link || onClick) && item.name) {
            return (react_1.default.createElement(next_components_custom_link_1.default, { key: item.name, href: linkToShow, onClick: onClick, title: item.name, ariaLabel: item.name, taggingInfo: Object.assign(Object.assign({}, taggingInfo), item.taggingInfo), className: "itemMenu" },
                react_1.default.createElement(next_components_text_info_n_1.default, { text: item.name, size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION1, color: color, fontType: fontType, segment: segment })));
        }
        // Si no queremos pintar un enlace, pintamos un textInfo si tiene nombre.
        if (item.name) {
            return (react_1.default.createElement(next_components_text_info_n_1.default, { text: item.name, size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION1, color: color, fontType: fontType, segment: segment }));
        }
        return null;
    })));
};
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(Menu);
//# sourceMappingURL=index.js.map